export class AddressDTO {
  addressType: string;
  addressNature: string;
  iso2country: string;
  city: string;
  zipCode: string;
  streetNumber: string;
  address: string;
  additionalAddress: string;
}
